import React from "react";
import {connect} from "react-redux";
import SuccessModal from "../../../../organisms/Modal/SuccessModal/SuccessModal";
import ErrorModal from "../../../../organisms/Modal/ErrorModal/ErrorModal";
import {NoSsr, withStyles} from "@material-ui/core";
import {isDefined} from "../../../../../utils";
import {compose} from "recompose";
import {withTranslation} from "react-i18next";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Typography from "@material-ui/core/Typography";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from "@material-ui/core/IconButton";
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import ColAtm from "../../../../atomic/Col/Col";
import {BASE_WEB} from "../../../../../constants/api.constants";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import {InputLabel} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

const THEMES = [
    { id: 1, label: 'Default Template',  name: 'Boutique', value: 'default' },
    { id: 2, label: 'Template 2',        name: 'Stork',    value: 'theme2'  },
    { id: 3, label: 'Template 3',        name: 'Oscar',    value: 'theme3'  },
    { id: 4, label: 'Template 4',        name: 'Qlusive',  value: 'theme4'  },
    { id: 5, label: 'Template 5',        name: 'Valencia', value: 'theme5'  },
    { id: 6, label: 'Template 6',        name: 'Solene'  , value: 'theme6'  },
    { id: 8, label: 'Template 8',        name: 'Folio'   , value: 'theme8'  },
];

const isZoomed = window.innerWidth >= 960 && window.innerWidth <= 1600;
const menuTransform = isZoomed ? 'translateX(325px)' : undefined;

let t=null;

const styles = theme => ({
    root: {
        margin: 'auto',
        height: "100%"
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button" />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class ShowLiveWeb extends React.Component {

    constructor(props){
        super(props);
        t = props.t;
        this.state = {
            selectedTheme: props.getEditContentWeb?.editWebData?.property_web_template?.folder_name || 'default',
            iframeLoading: true,
        };
    }

    handleThemeChange = (e) => {
        this.setState({ selectedTheme: e.target.value, iframeLoading: true });
    };

    componentDidUpdate(prevProps) {
        const prevTemplate = prevProps.getEditContentWeb?.editWebData?.property_web_template?.folder_name;
        const currTemplate = this.props.getEditContentWeb?.editWebData?.property_web_template?.folder_name;
        if (prevTemplate !== currTemplate) {
            this.setState({ selectedTheme: currTemplate || 'default' });
        }
        if (!prevProps.open && this.props.open) {
            this.setState({ iframeLoading: true });
        }
    }

    showMessages = () => {

        if( this.props.saveEditContentWeb.updateEditWebData && this.props.saveEditContentWeb.updateEditWebData.status === 200 ){

            var webLanguage = this.props.getEditContentWeb.editWebData.default_language;

            if(isDefined(this.props.getEditContentWeb.editWebData.property_web_language)){
                webLanguage = this.props.getEditContentWeb.editWebData.property_web_language.code;
            }

            const nativeTheme = this.props.getEditContentWeb.editWebData?.property_web_template?.folder_name || 'default';
            const themeParam = this.state.selectedTheme && this.state.selectedTheme !== nativeTheme
                ? '?theme=' + this.state.selectedTheme
                : '';
            const url = BASE_WEB + this.props.getEditContentWeb.editWebData.token + '/' + webLanguage + themeParam;

            const userEmail = this.props.profileReducer?.profileData?.profile?.email;

            if (this.props.show_success_modal) {
                return <SuccessModal status={true} message={t('enw-myw-site_save_msg')}/>
            } else if (!this.props.show_success_modal) {
                return <Dialog className="web-preview-dialog"
                               TransitionComponent={Transition}
                               aria-labelledby="customized-dialog-title"
                               fullScreen
                               open={this.props.open}
                               onClose={this.props.handleClose}
                >
                    <DialogTitle className="red-bottom-border" id="rate-plan" onClose={this.props.handleClose}>
                        <Grid container spacing={3} alignItems="center" style={{ paddingRight: 56 }}>
                            <Grid item>
                                { t('btn-preview') }
                            </Grid>
                            {userEmail?.endsWith('@extranetwork.com') && (
                                <Grid item style={{ marginLeft: 'auto' }}>
                                    <FormControl variant="outlined" size="small" className="theme-select-form-control">
                                        <InputLabel id="theme-select-label-edit">{t('enw-template-title')}</InputLabel>
                                        <Select
                                            labelId="theme-select-label-edit"
                                            label="Template"
                                            value={this.state.selectedTheme}
                                            onChange={this.handleThemeChange}
                                            style={{ minWidth: 210, background: '#fff', fontSize: 16 }}
                                            MenuProps={{
                                                PaperProps: {
                                                    style: {
                                                        transform: menuTransform
                                                    }
                                                }
                                            }}
                                        >
                                            {THEMES.map(theme => (
                                                <MenuItem key={theme.value} value={theme.value}>
                                                    {theme.id}. {theme.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                        </Grid>
                        <style>
                            {`
                                .theme-select-form-control {
                                    margin-top:10px!important;
                                }
                            `}
                        </style>
                    </DialogTitle>
                    <DialogContent>
                        <ColAtm container className="h-100" direction="row" md={12} style={{ position: 'relative' }}>
                            {this.state.iframeLoading && (
                                <div style={{
                                    position: 'absolute',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'rgba(255, 255, 255, 0.85)',
                                    zIndex: 10,
                                }}>
                                    <CircularProgress color="secondary" className="preview-loading-spinner" size={48} />
                                    <style>
                                        {`
                                            .preview-loading-spinner {
                                                top:50% !important;
                                            }
                                        `}
                                    </style>
                                </div>
                            )}
                            <iframe
                                className="site-preview-frame"
                                src={url}
                                title="site-preview-frame"
                                onLoad={() => this.setState({ iframeLoading: false })}
                            />
                        </ColAtm>
                    </DialogContent>
                </Dialog>
            }
        } else if (isDefined(this.props.saveEditContentWeb.error.response) ) {
            let message = this.props.saveEditContentWeb.error.response.data.message
            return <ErrorModal status={true} message={message}/>
        }
    }

    render() {
        return (
            <NoSsr>
                {
                    !this.props.saveEditContentWeb.fetching &&
                    <NoSsr>
                        {
                            this.showMessages()
                        }
                    </NoSsr>
                }
            </NoSsr>
        )
    }
}

const mapStateToProps = (state) => ({
    profileReducer: state.profileReducer
});

export default connect(mapStateToProps)(compose(withTranslation('common'))(ShowLiveWeb));
